
export type TweetResponseMediaItemDimensions = {
  height?: number;
  width?: number;
};
